var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4203_53",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4203_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 20.1668C9.73211 20.1668 8.54044 19.9262 7.42516 19.445C6.30988 18.9637 5.33975 18.3106 4.51475 17.4856C3.68975 16.6606 3.03662 15.6904 2.55537 14.5752C2.07412 13.4599 1.8335 12.2682 1.8335 11.0002C1.8335 9.73211 2.07412 8.54044 2.55537 7.42516C3.03662 6.30988 3.68975 5.33975 4.51475 4.51475C5.33975 3.68975 6.30988 3.03662 7.42516 2.55537C8.54044 2.07412 9.73211 1.8335 11.0002 1.8335C11.9932 1.8335 12.9328 1.97863 13.8189 2.26891C14.705 2.55919 15.5224 2.96405 16.271 3.4835L14.9418 4.83558C14.3613 4.46891 13.7425 4.18245 13.0856 3.9762C12.4286 3.76995 11.7335 3.66683 11.0002 3.66683C8.96822 3.66683 7.23801 4.38107 5.80954 5.80954C4.38107 7.23801 3.66683 8.96822 3.66683 11.0002C3.66683 13.0321 4.38107 14.7623 5.80954 16.1908C7.23801 17.6193 8.96822 18.3335 11.0002 18.3335C13.0321 18.3335 14.7623 17.6193 16.1908 16.1908C17.6193 14.7623 18.3335 13.0321 18.3335 11.0002C18.3335 10.7252 18.3182 10.4502 18.2877 10.1752C18.2571 9.90016 18.2113 9.6328 18.1502 9.37308L19.6397 7.8835C19.8078 8.37239 19.9377 8.87655 20.0293 9.396C20.121 9.91544 20.1668 10.4502 20.1668 11.0002C20.1668 12.2682 19.9262 13.4599 19.445 14.5752C18.9637 15.6904 18.3106 16.6606 17.4856 17.4856C16.6606 18.3106 15.6904 18.9637 14.5752 19.445C13.4599 19.9262 12.2682 20.1668 11.0002 20.1668ZM9.71683 15.2168L5.821 11.321L7.10433 10.0377L9.71683 12.6502L18.8835 3.46058L20.1668 4.74391L9.71683 15.2168Z",
    fill: "#1D8145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAlt);
export default __webpack_public_path__ + "static/media/task_alt.ef0f00226ae243e79bcdcbab9d51036f.svg";
export { ForwardRef as ReactComponent };